module.exports = __webpack_public_path__ + "img/btnStatus5.2d0db701.png";